import { createContext, useContext, useState, useEffect } from 'react';
import * as api from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const bootstrap = async () => {
            const twa = window.Telegram?.WebApp;
            const initData = twa?.initData;
            if (twa) { try { twa.ready(); twa.expand(); } catch {} }

            if (initData) {
                try {
                    const data = await api.telegramLogin(initData);
                    localStorage.setItem('token', data.token);
                    localStorage.setItem('user', JSON.stringify(data.user));
                    setUser(data.user);
                    setReady(true);
                    return;
                } catch (e) {
                    console.error('Telegram auth failed:', e);
                }
            }

            const token = localStorage.getItem('token');
            const stored = localStorage.getItem('user');
            if (token && stored) {
                try {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    if (payload.exp * 1000 > Date.now()) setUser(JSON.parse(stored));
                    else { localStorage.removeItem('token'); localStorage.removeItem('user'); }
                } catch { localStorage.removeItem('token'); localStorage.removeItem('user'); }
            }
            setReady(true);
        };
        bootstrap();
    }, []);

    const login = async (email, password) => {
        const data = await api.login({ email, password });
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    };

    const updateUser = (nextUser) => { setUser(nextUser); localStorage.setItem('user', JSON.stringify(nextUser)); };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        try { window.Telegram?.WebApp?.close(); } catch {}
    };

    if (!ready) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}><div className="spinner" /></div>;

    return <AuthContext.Provider value={{ user, login, logout, updateUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
